import { IWholesalerSupport } from '@cbgms/api'
import { UseMutationOptions, useMutation, useQueryClient } from '@cbgms/base/http/use-query'
import { useDispatch } from 'react-redux'
import { updateWholesaler } from '../state/actions'
import { wholesalerWithServiceKey } from './cache-keys'

interface InputProps {
  UUID: string
  wholesaler: Partial<IWholesalerSupport>
}

export const useMutateWholesaler = (options?: UseMutationOptions<void, unknown, InputProps, unknown> | undefined) => {
  const dispatch = useDispatch()
  const queryClient = useQueryClient()

  return useMutation(
    async ({ UUID, wholesaler }) => {
      await dispatch(updateWholesaler(UUID, wholesaler))
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess?.(data, variables, context)
        queryClient.invalidateQueries(wholesalerWithServiceKey(variables.UUID))
      }
    }
  )
}
